import { useContext } from 'react';
import { BarcodeLastIndexContext } from '../../contexts';

function useBarcodeGenerator() {
  const { barcodeLastIndex, setBarcodeLastIndex } = useContext(
    BarcodeLastIndexContext,
  );

  const padNumber = (n, l) => `${n}`.padStart(l, '0');

  const generateBarcodeValue = (
    permanentLocationId,
    locationCode,
    incrementNo = 1,
  ) => {
    if (permanentLocationId) {
      const newIndex = barcodeLastIndex + incrementNo;
      const libCode = locationCode
        ?.split('/')
        .slice(2)
        .join('.')
        .replace(/\//g, '.');
      const year = new Date().getFullYear().toString().replace('20', '');
      const month = new Date().getMonth() + 1;
      const generatedValue =
        libCode + year + padNumber(month, 2) + padNumber(newIndex, 6);
      setBarcodeLastIndex(newIndex);
      return generatedValue;
    } else {
      return '';
    }
  };

  return { barcodeLastIndex, generateBarcodeValue };
}

export default useBarcodeGenerator;
